(ns app.front.dashboard.inspections
  (:require [app.domain.booking.model :as booking-model]
            [app.domain.util :as du]
            [app.front.dashboard.common :as dashboard-common]
            [app.front.entities :as entities]
            [app.front.view.dispatch.subs :as dispatch-subs]
            [app.front.view.inspections.my-today :as inspections.my-today]
            [app.front.view.inspections.subs :as inspection-sub]
            [clojure.set :as set]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::queue-fetch-bookings
  (fn [{:keys [db]} _]
    (if (:session/user db)
      {:dispatch [::fetch-bookings]}
      {:async-flow {:rules [{:when     :seen-any-of?
                             :events   [:core.front.session/restored-session]
                             :dispatch [::fetch-bookings]
                             :halt?    true}]}})))

(rf/reg-event-fx ::fetch-bookings
  (fn [{:keys [db]} _]
    (when (->> (get-in db [:session/user :user/authority-groups])
               (mapcat :group-roles)
               set
               (set/intersection #{:group.role/dispatcher
                                   :group.role/inspector})
               seq)
      {:comm/command {:command    :booking/find-for-dashlet
                      :method     :get
                      :on-success [::fetch-bookings.success]}
       :db           (-> db
                         (assoc ::fetching? true))})))

(rf/reg-event-fx ::fetch-bookings.success
  (fn [{:keys [db]} [_ status resp]]
    {:dispatch [::entities/merge-entity-db status resp]
     :db       (-> db
                   (dissoc ::fetching?))}))

(rf/reg-sub ::fetching? :-> ::fetching?)

(def cancelled?
  (every-pred booking-model/cancelled?
              ;; We are not interested in old cancellations.
              ;; Also, only count bookings as cancelled if they have been
              ;; cancelled *after* having been dispatched. Otherwise, visiting
              ;; applications and then returning one may end up seeing a larger
              ;; number
              inspection-sub/booking-starts-today?))

(def dispatched?
  (du/in-state-fn :booking.state/dispatched))

(rf/reg-sub ::my-today-count
  :<- [::inspection-sub/my-bookings-for-today]
  :<- [::inspection-sub/ongoing-visits]
  :<- [::inspection-sub/my-external-events-for-today]
  (fn [[bookings on-going-visits external-events] _]
    (->> (filter dispatched? bookings)
         (concat on-going-visits external-events)
         count)))

(rf/reg-sub ::my-cancelled-today-count
  :<- [::inspection-sub/my-bookings-for-the-selected-day]
  (fn [bookings _]
    (count (filter cancelled? bookings))))

(rf/reg-sub ::bookings-to-dispatch-count
  :<- [::entities/entities {:entity/type :entity.type/booking}]
  (fn [bookings _]
    (count (filter booking-model/to-dispatch? bookings))))

(rf/reg-sub ::all-cancelled-bookings-count
  :<- [::entities/entities {:entity/type :entity.type/booking}]
  (fn [bookings _]
    (count (filter cancelled? bookings))))

(defn inspections-dashlet []
  (let [tr          (<sub [::inspection-sub/inspections-tr])
        inspector?  (<sub [:session/inspector-user?])
        dispatcher? (<sub [:session/dispatcher-user?])
        loading?    (<sub [::fetching?])]
    [:section.dashlet
     [:h2 (tr [:inspection/inspections])]
     [dashboard-common/link-box-container
      (when inspector?
        [:<>
         [dashboard-common/link-box-with-number (util/mmap {:title (tr [:inspection/my-today])
                                                            :href  (href/href :view/my-inspections)}
                                                           loading?)
          (<sub [::my-today-count])]
         (when (not dispatcher?)
           [dashboard-common/link-box-with-number (util/mmap {:title    (tr [:inspection/cancelled])
                                                              :href     (href/href :view/my-inspections)
                                                              :on-click #(>evt [::inspections.my-today/set-show-cancelled true])}
                                                             loading?)
            (<sub [::my-cancelled-today-count])])])
      (when dispatcher?
        [:<>
         [dashboard-common/link-box-with-number (util/mmap {:title    (tr [:inspection/dispatching])
                                                            :href     (href/href :view/dispatch)
                                                            :on-click #(>evt [::dispatch-subs/select-mode :requests])}
                                                           loading?)
          (<sub [::bookings-to-dispatch-count])]
         [dashboard-common/link-box-with-number (util/mmap {:title    (tr [:inspection/cancelled])
                                                            :href     (href/href :view/dispatch)
                                                            :on-click #(>evt [::dispatch-subs/select-mode :cancelled])}
                                                           loading?)
          (<sub [::all-cancelled-bookings-count])]])]]))
